<template lang="pug">
  b-container
    h4 Configuration
    b-card.mb-3
          p Branding
          b-form(ref='fileForm')
            b-form-group
              .row
                .col-md-4
                    b-form-group
                      label Favicon
                      b-form-file(v-model='files.favicon', accept=".ico", placeholder='Unchanged')
                      span.text-muted(v-if="files.favicon")
                        span.mr-2 Selected file:
                        i.fa.fa-file-csv.mr-2
                        span {{ files.favicon ? files.favicon.name : '' }}
                .col-md-4
                  b-form-group
                    label Icon
                    b-form-file(v-model='files.logo_icon', accept=".svg", placeholder='Unchanged')
                    span.text-muted(v-if="files.logo_icon")
                      span.mr-2 Selected file:
                      i.fa.fa-file-csv.mr-2
                      span {{ files.logo_icon ? files.logo_icon.name : '' }}
                .col-md-4
                  b-form-group
                    label Background
                    b-form-file(v-model='files.bg', accept=".jpg, .png, .gif", placeholder='Unchanged')
                    span.text-muted(v-if="files.bg")
                      span.mr-2 Selected file:
                      i.fa.fa-file-csv.mr-2
                      span {{ files.bg ? files.bg.name : '' }}
              .row
                .col-md-4
                  b-form-group
                    label Light logo
                    b-form-file(v-model='files.logo_light', accept=".svg", placeholder='Unchanged')
                    span.text-muted(v-if="files.logo_light")
                      span.mr-2 Selected file:
                      i.fa.fa-file-csv.mr-2
                      span {{ files.logo_light ? files.logo_light.name : '' }}
                .col-md-4
                  b-form-group
                    label Dark logo
                    b-form-file(v-model='files.logo_dark', accept=".svg", placeholder='Unchanged')
                    span.text-muted(v-if="files.logo_dark")
                      span.mr-2 Selected file:
                      i.fa.fa-file-csv.mr-2
                      span {{ files.logo_dark ? files.logo_light.name : '' }}
            b-button.mt-2.d-block(@click.stop="upload" variant='primary')
              loader(size="sm")
              span Upload
    b-card.mb-3
      p Business settings
      content-loader(v-if="!inputForm", :height="7")
      b-form(@submit='onSubmit', ref='inputForm', v-else='')
        .row
          .col-12.col-md-4
            b-form-group
              label Email
              b-form-input(type="text", required='', v-model='inputForm.email_info')
          .col-12.col-md-4
            b-form-group
              label Phone
              b-form-input(type="text", required='', v-model='inputForm.phone')
          .col-12.col-md-4
            b-form-group
              label Address
              b-form-input(type="text", required='', v-model='inputForm.address')
        .row
          .col-12.col-md-6
            b-form-group
              label Title
              b-form-input(type="text", required='', v-model='inputForm.site_title')
          .col-12.col-md-6
            b-form-group
              label Hub
              b-form-input(type="text", required='', v-model='inputForm.hub')
        .row
          .col-12
            b-form-group
              label Service areas
              b-form-tags(type='text', required='', placeholder="Add area...", v-model='inputForm.areas')
        .row
          .col-12.col-md-3
            b-form-group
              label Opening hour
              b-form-spinbutton(min="0", max="17", step="1", required='', v-model='inputForm.hour_open')
          .col-12.col-md-3
            b-form-group
              label Closing hour
              b-form-spinbutton(min="0", max="17", step="1", required='', v-model='inputForm.hour_close')
          .col-12.col-md-3
            b-form-group
              label Pickup cutoff
              b-form-spinbutton(min="0", max="17", step="1", required='', v-model='inputForm.hour_cutoff')
          .col-12.col-md-3
            b-form-group
              label Turnaround hours
              b-form-spinbutton(min="0", max="17", step="1", required='', v-model='inputForm.hour_turnaround')
          .col-12
            b-form-group
              label Order confirmation recipients
              b-form-tags(type='text', required='', placeholder="Add email...", v-model='inputForm.email_order')
        .row
          .col-4
            b-form-group
              label Facebook
              b-form-input(type="text", required='', v-model='inputForm.link_facebook')
          .col-4
            b-form-group
              label Instagram
              b-form-input(type="text", required='', v-model='inputForm.link_instagram')
          .col-4
            b-form-group
              label Twitter
              b-form-input(type="text", required='', v-model='inputForm.link_twitter')
        b-button(type='submit', variant='primary')
          loader(size="sm")
          span Save
    b-card.mb-3
      p Payfast account
      content-loader(v-if="!inputForm", :height="7")
      b-form(@submit='onSubmit', ref='inputForm', v-else='')
        .row
          .col-12.col-md-6
            b-form-group
              label Merchant id
              b-form-input(type="text", required='', v-model='inputForm.merchant_id')
          .col-12.col-md-6
            b-form-group
              label Merchant key
              b-form-input(type="text", required='', v-model='inputForm.merchant_key')
        b-button(type='submit', variant='primary')
          loader(size="sm")
          span Save
</template>

<script>
import { mapActions } from 'vuex';
import standardMix from '@/mixins/standardMix';

export default {
  name: 'Config',
  components: {
  },
  mixins: [standardMix],
  data() {
    return {
      themes: ['swift', 'tms'],
      inputForm: null,
      files: {
        favicon: null,
        bg: null,
        logo_icon: null,
        logo_light: null,
      },
    };
  },
  computed: {
    completedForm() {
      return {
        ...this.inputForm,
        // theme: this.inputForm.email_info.includes('swiftdrycleaners') ? 'swift' : 'tms',
        theme: 'swift',
      };
    },
  },
  methods: {
    ...mapActions('service', ['getConfig', 'updateConfig', 'uploadImages']),
    onSubmit(evt) {
      evt.preventDefault();
      this.updateConfig(this.completedForm);
    },
    upload() {
      const formData = new FormData();
      if (this.files.favicon) formData.append('favicon.ico', this.files.favicon);
      if (this.files.bg) formData.append('bg.jpg', this.files.bg);
      if (this.files.logo_icon) formData.append('logo_icon.svg', this.files.logo_icon);
      if (this.files.logo_light) formData.append('logo_light.svg', this.files.logo_light);
      if (this.files.logo_dark) formData.append('logo_dark.svg', this.files.logo_dark);
      this.uploadImages(formData);
    },
  },
  async mounted() {
    // Config already fetched in app.vue
    this.inputForm = this.config;
  },
};
</script>

<style lang="scss" scoped>
input:disabled {
    border: none !important;
    background: transparent;
    color: gray;
}
</style>



// WEBPACK FOOTER //
// src/components/views/Config.vue